import { Component, EventEmitter, Output, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonModalComponent } from '../modal/modal.component';
import { ButtonComponent } from 'pi-ui';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-two-factor-reminder-modal',
    templateUrl: './two-factor-reminder-modal.component.html',
    styleUrls: ['./two-factor-reminder-modal.component.scss'],
    imports: [
        CommonModalComponent,
        ButtonComponent,
        TranslateModule,
    ],
})
export class TwoFactorReminderModalComponent {
  readonly bsModal = inject(BsModalRef);

  @Output() action: EventEmitter<boolean> = new EventEmitter<boolean>();

  goToProfileSettings(): void {
    this.action.emit(true);
    this.bsModal.hide();
  }

  close(): void {
    this.action.emit(false);
    this.bsModal.hide();
  }
}
